export default __webpack_public_path__ + "static/media/naverBlog.dcff6b01.svg";